/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import moment from 'moment';
import c from 'classnames';
import {
    Accordion,
    AccordionDetails,
    Tooltip,
    Select,
    MenuItem,
    withStyles,
    Checkbox,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
} from '@material-ui/core';
import PropTypes from 'prop-types';
// import * as XLSX from 'xlsx';
import XLSX from 'xlsx-color';
import { KeyboardArrowDownSharp } from '@material-ui/icons';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import InfoIcon from '../../../assets/InfoIcon.svg';
import './index.scss';
import { USNumFormat } from '../../../utils/functions';
import CloseIcon from '../../../assets/Close.svg';
// import ArrowBackward from '../../Diagnose/assets/Small-left.svg';
import ArrowForward from '../../Diagnose/assets/Small-right.svg';
import ArrowDoubleBack from '../../Diagnose/assets/Double-arrow-left.svg';
import ArrowDoubleForward from '../../Diagnose/assets/Double-arrow-right.svg';
import Refresh from '../../Reports/assets/Refresh.svg';
import ConfirmModal from './ConfirmModal';
import searchBar from '../../UserReports/assets/zoom.svg';
// import Down from '../../UserReports/assets/D'
import Down from '../../Diagnose/assets/Down.svg';
import ActiveFilter from '../../Diagnose/assets/ActiveFilters1.svg';
import FilterSvg from '../../Diagnose/assets/Filter.svg';
import CloudImage from '../assets/InsufficientData1.svg';
import ArrowRight from '../../UserReports/assets/arrowRight.svg';
import SmallLeft from '../assets/smallLeft.svg';
import PaginationItems from '../assets/paginationItems.svg';
import { realtimeDownloadUrl } from '../apis';

const dummyData = [
    { keyName: 'total_survey', value: 'Total surveys' },
    { keyName: 'total_responded', value: 'Total respondents' },
    { keyName: 'approve_survey', value: 'Approved surveys' },
    { keyName: 'approve_responded', value: 'Approved respondents' },
];

const BENCHMARK_STATUS_FILTER_OPTIONS = ['Pending', 'Research Approved', 'BMX Approved', 'Both Approved', 'Rejected'];

const COLUMNS_WITHOUT_FILTER = ['action', 'uniquesurveyreferencecode', 'surveyclientname', 'resurveyid'];

// Alternate API key names (snake_case) for columns that may come from API with different naming
const COLUMN_KEY_ALIASES = {
    datarestriction: ['data_restriction'],
    georestriction: ['geo_restriction'],
    expertname: ['expert_name'],
    samplevalue: ['sample_value'],
    orgsciallowed: ['org_sci_allowed'],
};

const getCellValue = (obj, key) => {
    if (!obj) return null;
    const val = obj[key];
    if (val != null && val !== '') return val;
    const aliases = COLUMN_KEY_ALIASES[key];
    if (aliases) {
        for (let i = 0; i < aliases.length; i += 1) {
            const v = obj[aliases[i]];
            if (v != null && v !== '') return v;
        }
    }
    return val;
};

const CREATE_CUSTOM_BM = [
    // {
    //     key: 'selectid',
    //     title: '',
    //     width: '4vw',
    // },
    {
        key: 'action',
        title: 'Actionable',
        width: '9.78vw',
        widthTd: '9.9vw',
        cursor: 'pointer',
    },
    {
        key: 'approve_status',
        title: 'Benchmark Status',
        width: '14vw',
        widthTd: '14.2vw',
        cursor: 'pointer',
    },
    {
        key: 'uniquesurveyreferencecode',
        title: 'OHI ID',
        width: '10vw',
        widthTd: '10.2vw',
        cursor: 'pointer',
    },
    // {
    //     key: 'confirmitsurveyid',
    //     title: 'PID',
    //     width: '12vw',
    //     cursor: 'pointer',
    // },
    {
        key: 'surveyclientname',
        title: 'Organization Name',
        width: '18vw',
        widthTd: '18.2vw',
        cursor: 'pointer',
    },
    {
        key: 'isgsdbfilled',
        title: 'GSOD Filled',
        width: '6vw',
        widthTd: '6.2vw',
        cursor: 'pointer',
    },
    {
        key: 'legalcheck',
        title: 'Legal Check',
        width: '6vw',
        widthTd: '6.1vw',
        cursor: 'pointer',
    },
    {
        key: 'benchmarkingallowed',
        title: 'Benchmarking Allowed',
        width: '12vw',
        widthTd: '12.1vw',
        cursor: 'pointer',
    },
    {
        key: 'type',
        title: 'Type',
        width: '7vw',
        widthTd: '7.2vw',
        cursor: 'pointer',
    },
    {
        key: 'ohi_version',
        title: 'Survey Version',
        width: '10.2vw',
        widthTd: '10.3vw',
        cursor: 'pointer',
    },
    {
        key: 'isresurvey',
        title: 'Resurvey',
        width: '7vw',
        widthTd: '7.1vw',
        cursor: 'pointer',
    },
    {
        key: 'resurveyid',
        title: 'Resurvey ID',
        width: '8vw',
        widthTd: '8.2vw',
        cursor: 'pointer',
    },
    {
        key: 'is_ex_survey',
        title: 'Is EX Survey',
        width: '7vw',
        widthTd: '7.2vw',
        cursor: 'pointer',
    },
    {
        key: 'is_ex_full_survey',
        title: 'EX Type',
        width: '7vw',
        widthTd: '7.2vw',
        cursor: 'pointer',
    },
    {
        key: 'totalcomplete',
        title: 'Complete Responses',
        width: '6vw',
        widthTd: '6.1vw',
        align: 'right',
        cursor: 'pointer',
    },
    // {
    //     key: 'bm_year',
    //     title: 'Benchmarking Year',
    //     width: '8vw',
    //     align: 'center',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'quartile',
    //     title: 'Global Quartile',
    //     width: '10vw',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'mckinseysectorlevel1',
    //     title: 'Sector Level 1',
    //     width: '20vw',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'mckinseysectorlevel2',
    //     title: 'Sector Level 2',
    //     width: '20vw',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'region',
    //     title: 'Region',
    //     width: '10vw',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'subregion1',
    //     title: 'Subregion (high level)',
    //     width: '15vw',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'subregion2',
    //     title: 'Subregion (detailed)',
    //     width: '15vw',
    //     cursor: 'pointer',
    // },
    // {
    //     key: 'country',
    //     title: 'Country',
    //     width: '15vw',
    //     cursor: 'pointer',
    // },
    {
        key: 'close_date',
        title: 'Closed Date',
        width: '10vw',
        widthTd: '10.2vw',
        cursor: 'pointer',
    },
    {
        key: 'lg_benchmarking_permitted',
        title: 'Benchmarking Permitted by Legal Agreements',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'lg_included_OP_questions',
        title: 'Complete Coverage of Outcomes and Practices',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'lg_core_questions_not_changed',
        title: 'Core OHI Questions Remained Unchanged',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'lg_included_all_employees',
        title: 'Representative Employee Sample Used',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'verification_checked',
        title: 'Verification Check',
        width: '10vw',
        widthTd: '10vw',
        cursor: 'pointer',
    },
    {
        key: 'datarestriction',
        title: 'Data Restriction',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'georestriction',
        title: 'Geo Restriction',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'population',
        title: 'Population',
        width: '10vw',
        widthTd: '10.2vw',
        cursor: 'pointer',
    },
    {
        key: 'subpopulation_name',
        title: 'Subpopulation',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'expertname',
        title: 'Expert Name',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'coach_name',
        title: 'Coach Name',
        width: '12vw',
        widthTd: '12.2vw',
        cursor: 'pointer',
    },
    {
        key: 'samplevalue',
        title: 'Sample Value',
        width: '10vw',
        widthTd: '10.2vw',
        cursor: 'pointer',
    },
    {
        key: 'orgsciallowed',
        title: 'Org Science Allowed',
        width: '14vw',
        widthTd: '14.2vw',
        cursor: 'pointer',
    },
    {
        key: 'org_science_other_text',
        title: 'Org Science Other Text',
        width: '16vw',
        widthTd: '16.2vw',
        cursor: 'pointer',
    },
];

const RealtimeDatabase = ({
    defaultRealTimeYear,
    realtimeTotalData = {},
    realtimeSurveyList = [],
    getRealtimeApproval,
    getRealtimeReject,
    getRealtimeSurveyList,
    // hideSecondPopup,
    secondPopupVisible,
    getRealtimeAnalytics,
    // new
    realtimeToggleFilterView,
    renderRealtimeFilterApplied,
    realtimeFilterString,
    refreshMetaRequest,
    refreshMetaData,
    // renderFilterApplied,
    realtimeFiltersApplied = false,
}) => {
    const [popupContent, setPopupContent] = useState(false);
    const [popupConfirmationContent, setPopupConfirmationContent] = useState(false);
    const [realtimeId, setRealtimeId] = useState();
    const [uniqueSurveyReferencecodeValue, setUniqueSurveyReferencecodeValue] = useState('');
    const [showPopupBtn, setShowPopupBtn] = useState('');
    const [showRefreshModal, setRefreshModal] = useState(false);
    const [showRefreshModalMsg, setRefreshModalMsg] = useState(false);
    const [refreshItem, setRefreshItem] = useState({ id: '', bm_year: '', msg: '' });
    // const [page, setPage] = useState(1);
    // const [min, setMinSlice] = useState(0);
    // const [max, setMaxSlice] = useState(5);
    // const [entryCount, setEntryCount] = useState(10);
    const { success = [], failed = [] } = refreshMetaData || {};
    const refreshData = success.length ? success : failed;
    const { detail = '' } = refreshData[0] || {};
    const { msg } = refreshItem || {};
    const [searchInput, setSearchInput] = useState('');
    const [approveBMX, setApproveBMX] = useState(false);
    const [approveResearch, setApproveResearch] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [researchStatus, setResearchStatus] = useState('');
    const [benchmarkStatus, setBenchmarkStatus] = useState('');
    const [exportModalVisible, setExportModalVisible] = useState(false);
    const [exportOptions, setExportOptions] = useState({
        metadata: false,
        scoreOHI: false,
        exScore: false,
        questionLevelScore: false,
    });
    const hasShownRefreshSuccessRef = useRef(false);
    const REFRESH_TRIGGERED_KEY = 'realtimeRefreshTriggeredAt';
    const REFRESH_TRIGGERED_MAX_AGE_MS = 15000;

    useLayoutEffect(() => {
        if (refreshData.length > 0) {
            try {
                const triggeredAt = sessionStorage.getItem(REFRESH_TRIGGERED_KEY);
                if (triggeredAt) {
                    const age = Date.now() - parseInt(triggeredAt, 10);
                    sessionStorage.removeItem(REFRESH_TRIGGERED_KEY);
                    if (age <= REFRESH_TRIGGERED_MAX_AGE_MS) {
                        hasShownRefreshSuccessRef.current = false;
                        return;
                    }
                }
            } catch (e) {
                // ignore
            }
            hasShownRefreshSuccessRef.current = true;
        }
    }, []);

    useEffect(() => {
        if (secondPopupVisible) {
            if (defaultRealTimeYear) {
                getRealtimeAnalytics(`year:${defaultRealTimeYear}`);
            }
            if (defaultRealTimeYear) {
                getRealtimeSurveyList(`year:${defaultRealTimeYear}`);
            }
        }
        // eslint-disable-next-line
    }, [defaultRealTimeYear, secondPopupVisible]);

    useEffect(() => {
        if (popupContent) {
            // Set default checkbox values based on API response
            const isBMXApproved =
                benchmarkStatus === 'BMX Approved' ||
                benchmarkStatus === 'Both Approved' ||
                benchmarkStatus === 'Approved' ||
                benchmarkStatus === 'approved';
            const isResearchApproved =
                researchStatus === 'Research Approved' ||
                researchStatus === 'Both Approved' ||
                researchStatus === 'Approved' ||
                researchStatus === 'approved';

            setApproveBMX(isBMXApproved);
            setApproveResearch(isResearchApproved);

            // Set default radio button value
            if (benchmarkStatus === 'Rejected' || benchmarkStatus === 'rejected') {
                setRejectionReason('reject_and_track');
            } else {
                setRejectionReason('');
            }
        } else if (!popupContent && !popupConfirmationContent) {
            // Reset states only when BOTH popups are closed
            setApproveBMX(false);
            setApproveResearch(false);
            setRejectionReason('');
        }
    }, [popupContent, popupConfirmationContent, benchmarkStatus, researchStatus]);

    const LightTooltip = withStyles(theme => ({
        arrow: {
            color: theme.palette.common.black,
        },
        tooltip: {
            backgroundColor: '#333333',
            color: '#fff',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            maxWidth: 'none',
            width: '400px',
            whiteSpace: 'normal',
            padding: '10px',
            borderRadius: '4px',
        },
    }))(Tooltip);

    const processSurveyList = list => {
        // Ensure list is an array before mapping
        if (!Array.isArray(list)) {
            return [];
        }
        return list.map(item => {
            let action = '';
            const actionable = '';

            switch (item.benchmark_status) {
                case 'pending':
                case 'approved':
                case 'rejected':
                    action = (
                        <>
                            <div
                                style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}
                            >
                                <div className="explore">TAKE ACTION</div>
                                <img src={ArrowRight} alt="" />
                            </div>
                        </>
                    );
                    break;
                default:
                    action = '';
            }
            return { ...item, action, actionable };
        });
    };

    const getStatusStyles = status => {
        switch (status) {
            case 'pending':
                return { backgroundColor: '#fff9d7', color: '#d19b3e', padding: '6px', borderRadius: '8px' };
            case 'Pending':
                return { backgroundColor: '#fff9d7', color: '#d19b3e', padding: '6px', borderRadius: '8px' };
            case 'approved':
                return { backgroundColor: '#defae6', color: '#027f26', padding: '6px', borderRadius: '8px' };
            case 'Approved':
                return { backgroundColor: '#defae6', color: '#027f26', padding: '6px', borderRadius: '8px' };
            case 'BMX Approved':
                return { backgroundColor: '#defae6', color: '#027f26', padding: '6px', borderRadius: '8px' };
            case 'Both Approved':
                return { backgroundColor: '#defae6', color: '#027f26', padding: '6px', borderRadius: '8px' };
            case 'Research Approved':
                return { backgroundColor: '#defae6', color: '#027f26', padding: '6px', borderRadius: '8px' };
            case 'rejected':
                return { backgroundColor: '#fde7e7', color: '#d72c3b', padding: '6px', borderRadius: '8px' };
            case 'Rejected':
                return { backgroundColor: '#fde7e7', color: '#d72c3b', padding: '6px', borderRadius: '8px' };
            default:
                return { backgroundColor: 'white', color: 'black', padding: '6px', borderRadius: '8px' };
        }
    };

    const BENCHMARK_STATUS_DISPLAY_MAP = {
        pending: 'Pending',
        'research approved': 'Research Approved',
        'bmx approved': 'BMX Approved',
        'both approved': 'Both Approved',
        rejected: 'Rejected',
    };

    const getDisplayValue = (obj, key) => {
        if (!obj || !key) return '';
        if (key === 'approve_status') {
            const v = obj.approve_status;
            if (v == null || v === '') return '';
            const normalized = String(v)
                .toLowerCase()
                .trim();
            return BENCHMARK_STATUS_DISPLAY_MAP[normalized] || String(v);
        }
        if (key === 'close_date') return obj[key] ? moment(obj[key]).format('MMM-YYYY') : '';
        if (key === 'bm_year') return obj[key] != null ? String(obj[key]) : '';
        if (key === 'isgsdbfilled' || key === 'legalcheck') {
            const v = obj[key];
            const isTrue = v === '1' || v === 1 || v === true || String(v).toLowerCase() === 'true';
            return isTrue ? 'True' : 'False';
        }
        if (key === 'is_ex_survey') return obj[key] === '1' ? 'Yes' : 'No';
        if (key === 'is_ex_full_survey') {
            if (obj.is_ex_survey === '1' && obj.is_ex_full_survey === '1') return 'Full';
            if (obj.is_ex_survey === '1' && obj.is_ex_full_survey === '0') return 'Pulse';
            return '-';
        }
        if (
            key === 'lg_benchmarking_permitted' ||
            key === 'lg_included_OP_questions' ||
            key === 'lg_core_questions_not_changed' ||
            key === 'lg_included_all_employees' ||
            key === 'verification_checked'
        ) {
            return obj[key] === true ? 'True' : 'False';
        }
        if (key === 'action')
            return obj.benchmark_status && ['pending', 'approved', 'rejected'].includes(obj.benchmark_status)
                ? 'TAKE ACTION'
                : '';
        const textKeys = [
            'datarestriction',
            'georestriction',
            'population',
            'subpopulation_name',
            'expertname',
            'coach_name',
            'samplevalue',
            'orgsciallowed',
            'org_science_other_text',
        ];
        if (textKeys.includes(key)) {
            const val = getCellValue(obj, key);
            return val != null && val !== '' ? String(val) : '';
        }
        const val = obj[key];
        return val != null && val !== '' ? String(USNumFormat(val)) : '';
    };

    const processedSurveyList = processSurveyList(Array.isArray(realtimeSurveyList) ? realtimeSurveyList : []);
    const [columnFilters, setColumnFilters] = useState({});
    const [page, setPage] = useState(1);
    const [min, setMinSlice] = useState(0);
    const [max, setMaxSlice] = useState(5);
    const [entryCount, setEntryCount] = useState(10);

    const normalizeString = str => {
        if (!str) return '';
        return str.toLowerCase().replace(/\s+/g, '');
    };

    const filteredData = useMemo(() => {
        let result = processedSurveyList;
        if (searchInput && normalizeString(searchInput)) {
            const normalizedInput = normalizeString(searchInput);
            result = result.filter(
                ({ uniquesurveyreferencecode = '', confirmitsurveyid = '', surveyclientname = '' }) =>
                    normalizeString(uniquesurveyreferencecode).includes(normalizedInput) ||
                    normalizeString(confirmitsurveyid).includes(normalizedInput) ||
                    normalizeString(surveyclientname).includes(normalizedInput)
            );
        }
        Object.entries(columnFilters).forEach(([colKey, selectedValue]) => {
            if (selectedValue !== '' && selectedValue != null) {
                result = result.filter(row => getDisplayValue(row, colKey) === selectedValue);
            }
        });
        return result;
    }, [processedSurveyList, searchInput, columnFilters]);

    const lastPage = Math.ceil(filteredData.length / entryCount);

    const handleNextPage = () => {
        if (page < lastPage) {
            setPage(page + 1);
            if (page + 1 > max) {
                setMinSlice(min + 5);
                setMaxSlice(max + 5);
            }
        }
    };

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
            if (page - 1 <= min) {
                setMinSlice(min - 5);
                setMaxSlice(max - 5);
            }
        }
    };

    const handleFirstPageSlice = () => {
        setPage(1);
        setMinSlice(0);
        setMaxSlice(5);
    };

    const handleLastPageSlice = () => {
        setPage(lastPage);
        const lastSliceStart = Math.floor((lastPage - 1) / 5) * 5;
        setMinSlice(lastSliceStart);
        setMaxSlice(lastSliceStart + 5);
    };

    const handleResultsPerPageChange = e => {
        setEntryCount(e.target.value);
        setPage(1);
        setMinSlice(0);
        setMaxSlice(5);
    };

    useEffect(() => {
        setPage(1);
        setMinSlice(0);
        setMaxSlice(5);
    }, [searchInput, columnFilters]);

    const handleSearchChange = e => {
        setSearchInput(e.target.value);
    };

    const handleColumnFilterChange = (columnKey, value) => {
        setColumnFilters(prev => ({ ...prev, [columnKey]: value }));
    };

    const getColumnFilterOptions = columnKey => {
        if (columnKey === 'approve_status') {
            return ['', ...BENCHMARK_STATUS_FILTER_OPTIONS];
        }
        if (columnKey === 'isgsdbfilled' || columnKey === 'legalcheck') {
            return ['', 'True', 'False'];
        }
        const uniqueValues = new Set();
        processedSurveyList.forEach(row => {
            const displayVal = getDisplayValue(row, columnKey);
            if (displayVal !== '') uniqueValues.add(displayVal);
        });
        return ['', ...Array.from(uniqueValues).sort((a, b) => String(a).localeCompare(String(b)))];
    };

    // const lastPage = Math.ceil(processedSurveyList.length / entryCount);
    // console.log('processedSurveyList', processedSurveyList);

    // const lastPage = Math.ceil(processedSurveyList.length / entryCount);

    // const downloadExcel = () => {
    //     const worksheet = XLSX.utils.json_to_sheet(realtimeSurveyList);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Survey Data');
    //     const currentDate = new Date().toLocaleDateString();
    //     const currentTimestamp = new Date().toLocaleTimeString();
    //     const realNameExcel = `SurveyData_${currentDate}_${currentTimestamp}.xlsx`;
    //     XLSX.writeFile(workbook, realNameExcel);
    // };

    const handleCellClick = (id, key, uniquesurveyreferencecode, research_status, benchmark_status) => {
        setShowPopupBtn(key);
        setRealtimeId(id);
        setUniqueSurveyReferencecodeValue(uniquesurveyreferencecode);
        setPopupContent(true);
        setResearchStatus(research_status);
        setBenchmarkStatus(benchmark_status);
    };

    const closePopup = () => {
        setPopupContent(false);
        setPopupConfirmationContent(false);
        setResearchStatus('');
        setBenchmarkStatus('');
        setUniqueSurveyReferencecodeValue('');
        setApproveBMX(false);
        setApproveResearch(false);
        setRejectionReason('');
    };

    const handleExportModalOpen = () => {
        setExportModalVisible(true);
    };

    const handleExportModalClose = () => {
        setExportModalVisible(false);
        setExportOptions({
            metadata: false,
            scoreOHI: false,
            exScore: false,
            questionLevelScore: false,
        });
    };

    const handleExportOptionChange = option => {
        setExportOptions(prev => ({
            ...prev,
            [option]: !prev[option],
        }));
    };

    const handleExport = async () => {
        try {
            // Call the download API with the filter string
            const response = await realtimeDownloadUrl({
                filters: realtimeFilterString,
                include_meta: exportOptions.metadata,
                include_ohi_score: exportOptions.scoreOHI,
                include_ex_score: exportOptions.exScore,
                include_qbyq_score: exportOptions.questionLevelScore,
            });

            if (!response.ok) {
                throw new Error('Download failed');
            }

            // Get the blob from response
            const blob = await response.blob();

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Generate filename with timestamp
            const currentDate = new Date().toLocaleDateString().replace(/\//g, '-');
            const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
            link.download = `RealTimeData_${currentDate}_${currentTime}.xlsx`;

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            handleExportModalClose();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Export failed:', error);
            // You can add error toast notification here
            handleExportModalClose();
        }
    };

    const handleApprove = () => {
        getRealtimeApproval({
            year: defaultRealTimeYear,
            is_benchmark_approved: approveBMX,
            is_research_approved: approveResearch,
            id: [realtimeId],
        });
        closePopup();
    };

    const handleReject = () => {
        getRealtimeReject({
            year: defaultRealTimeYear,
            id: [realtimeId],
        });
        closePopup();
    };

    const handleRefreshBtnClick = (id, year) => {
        const { uniquesurveyreferencecode } = processedSurveyList.find(({ id: s_id }) => s_id === id);
        setRefreshModal(true);
        setRefreshItem({
            id,
            bm_year: year,
            msg: `Do you want to refresh the meta information and score for ${uniquesurveyreferencecode} (${year}). Refreshing the OHID will update the meta information and score`,
        });
    };

    const handleRefreshAction = () => {
        const { id, bm_year } = refreshItem;
        hasShownRefreshSuccessRef.current = false;
        try {
            sessionStorage.setItem(REFRESH_TRIGGERED_KEY, String(Date.now()));
        } catch (e) {
            // ignore
        }
        refreshMetaRequest({ id: [id], year: bm_year });
        setRefreshModal(false);
    };

    const handleClose = () => {
        setRefreshModal(false);
    };

    // const handleRefresh = () => {
    //     if (defaultRealTimeYear) {
    //         getRealtimeAnalytics(`year:${defaultRealTimeYear}`);
    //     }
    //     if (defaultRealTimeYear) {
    //         getRealtimeSurveyList(`year:${defaultRealTimeYear}`);
    //     }
    //     hideSecondPopup();
    // };
    useEffect(() => {
        if (refreshData.length && !hasShownRefreshSuccessRef.current) {
            setRefreshModalMsg(true);
            hasShownRefreshSuccessRef.current = true;
        }
        // eslint-disable-next-line
    }, [refreshMetaData]);
    return (
        <div className="realTimeData">
            <div className="realtimeMainHead">
                <div className="realTimeHead">
                    <div className="realTimeHeading">Realtime Database</div>
                    <div className="nRes">{`${'WIP Year'} : ${defaultRealTimeYear}`}</div>
                </div>

                <ul className="navScoreList">
                    <li data-testid="getPptBtn" onClick={handleExportModalOpen}>
                        <img src={Down} alt="" />
                        <span className="lineHead upperHead">Download excel File</span>
                    </li>
                    <li onClick={() => realtimeToggleFilterView(true)} data-testid="filterButton">
                        <img src={!realtimeFiltersApplied ? FilterSvg : ActiveFilter} alt="" />
                        <span className="filter">Filter</span>
                    </li>
                </ul>
            </div>
            <div className="realtimeFilter">{renderRealtimeFilterApplied}</div>
            <div className="realtimeSection">
                <div className="cardContainer">
                    {realtimeTotalData &&
                        typeof realtimeTotalData === 'object' &&
                        Object.keys(realtimeTotalData)
                            .slice(0, 2)
                            .map(key => {
                                const realTimeData = dummyData.slice(0, 2).find(item => item.keyName === key).value;
                                return (
                                    <div className="cardContent" key={realtimeTotalData[key]}>
                                        <div className="cardHead">{realTimeData}</div>
                                        <div className="cardSubHead">
                                            {realtimeTotalData[key].toLocaleString('en-US')}
                                        </div>
                                    </div>
                                );
                            })}
                </div>

                <div className="cardContainer">
                    {realtimeTotalData &&
                        typeof realtimeTotalData === 'object' &&
                        Object.keys(realtimeTotalData)
                            .slice(2, 4)
                            .map(key => {
                                const realTimeData1 = dummyData.slice(2, 4).find(item => item.keyName === key).value;
                                return (
                                    <div className="cardContent" key={realtimeTotalData[key]}>
                                        <div className="cardHead">{realTimeData1}</div>
                                        <div className="cardSubHead">
                                            {realtimeTotalData[key].toLocaleString('en-US')}
                                        </div>
                                    </div>
                                );
                            })}
                </div>
            </div>

            {/* <div>
                <div>
                    <div>Survey List</div>
                </div>

                <div className="searchBar">
                        <input
                            type="text"
                            placeholder="Search"
                            value={searchInput}
                            onChange={handleSearchChange}
                            className="search"
                        />
                        <div className="searchIcon">
                            <img src={searchBar} alt="" />
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="realtimeSearchContent">
                <div className="realtimeHeading">Survey List</div>

                <div className="searchBar">
                    <input
                        type="text"
                        // placeholder="Search"
                        placeholder="Search by OHI ID, PID, Organization Name"
                        value={searchInput}
                        onChange={handleSearchChange}
                        className="search"
                    />
                    <div className="searchIcon">
                        <img src={searchBar} alt="" />
                    </div>
                </div>
            </div>

            <div className="userReportsContent xScroll">
                <Accordion classes={{ root: 'accordionRoot' }} key="table" expanded>
                    <AccordionDetails classes={{ root: 'clearfix' }}>
                        <table className="userSection">
                            <tbody className="userContent">
                                <thead className="headerSection">
                                    <tr>
                                        <th style={{ width: '1.6vw' }} />
                                        {CREATE_CUSTOM_BM.map(({ key, title, width }) => {
                                            const hasFilter = !COLUMNS_WITHOUT_FILTER.includes(key);
                                            return (
                                                <th
                                                    className={c('headerHeading', {
                                                        headerHeadingWithFilter: hasFilter,
                                                    })}
                                                    key={key}
                                                    style={{ width }}
                                                >
                                                    <div className="headerCellContent">
                                                        <span className="headerTitle">{title}</span>
                                                        {hasFilter && (
                                                            <Select
                                                                className="columnFilterSelect"
                                                                value={
                                                                    columnFilters[key] != null ? columnFilters[key] : ''
                                                                }
                                                                onChange={e =>
                                                                    handleColumnFilterChange(key, e.target.value)
                                                                }
                                                                displayEmpty
                                                                MenuProps={{
                                                                    anchorOrigin: {
                                                                        vertical: 'bottom',
                                                                        horizontal: 'left',
                                                                    },
                                                                    transformOrigin: {
                                                                        vertical: 'top',
                                                                        horizontal: 'left',
                                                                    },
                                                                }}
                                                            >
                                                                <MenuItem value="">
                                                                    <em>All</em>
                                                                </MenuItem>
                                                                {getColumnFilterOptions(key)
                                                                    .filter(v => v !== '')
                                                                    .map(opt => (
                                                                        <MenuItem key={opt} value={opt}>
                                                                            {opt}
                                                                        </MenuItem>
                                                                    ))}
                                                            </Select>
                                                        )}
                                                    </div>
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>

                                {!!filteredData.length &&
                                    filteredData.slice((page - 1) * entryCount, page * entryCount).map(obj => {
                                        const {
                                            id = '',
                                            action = '',
                                            benchmark_status,
                                            bm_year,
                                            is_allow_meta_update,
                                            uniquesurveyreferencecode,
                                            approve_status,
                                            research_status,
                                        } = obj || {};
                                        return (
                                            <>
                                                <tr key={id} className="userDataSection">
                                                    {is_allow_meta_update ? (
                                                        <LightTooltip
                                                            title="The survey details are refreshed for the current year surveys only (till its status is pending). Details of surveys which are part of approved benchmarks are not refreshed."
                                                            arrow
                                                        >
                                                            <td
                                                                onClick={() => handleRefreshBtnClick(id, bm_year)}
                                                                className="refreshBtn"
                                                            >
                                                                <img src={Refresh} alt="" />
                                                            </td>
                                                        </LightTooltip>
                                                    ) : (
                                                        <LightTooltip
                                                            title="Meta update is not allowed for this survey."
                                                            arrow
                                                        >
                                                            <td className="refreshBtn disabled">
                                                                <img src={Refresh} alt="" style={{ opacity: 0.5 }} />
                                                            </td>
                                                        </LightTooltip>
                                                    )}
                                                    {CREATE_CUSTOM_BM.map(
                                                        ({ key, widthTd, width, align = '', cursor }) => {
                                                            let dataValue =
                                                                key === 'close_date'
                                                                    ? moment(obj[key]).format('MMM-YYYY')
                                                                    : USNumFormat(obj[key]);
                                                            if (key === 'bm_year') {
                                                                dataValue = obj[key];
                                                            }
                                                            if (key === 'isgsdbfilled' || key === 'legalcheck') {
                                                                const v = obj[key];
                                                                const isTrue =
                                                                    v === '1' ||
                                                                    v === 1 ||
                                                                    v === true ||
                                                                    String(v).toLowerCase() === 'true';
                                                                dataValue = isTrue ? 'True' : 'False';
                                                            }
                                                            if (key === 'is_ex_survey') {
                                                                dataValue = dataValue === '1' ? 'Yes' : 'No';
                                                            }
                                                            if (key === 'is_ex_full_survey') {
                                                                // EX Type logic: Full, Pulse, or -
                                                                if (
                                                                    obj.is_ex_survey === '1' &&
                                                                    obj.is_ex_full_survey === '1'
                                                                ) {
                                                                    dataValue = 'Full';
                                                                } else if (
                                                                    obj.is_ex_survey === '1' &&
                                                                    obj.is_ex_full_survey === '0'
                                                                ) {
                                                                    dataValue = 'Pulse';
                                                                } else if (obj.is_ex_survey === '0') {
                                                                    dataValue = '-';
                                                                } else {
                                                                    dataValue = '-';
                                                                }
                                                            }
                                                            // Handle new legal/verification columns
                                                            if (
                                                                key === 'lg_benchmarking_permitted' ||
                                                                key === 'lg_included_OP_questions' ||
                                                                key === 'lg_core_questions_not_changed' ||
                                                                key === 'lg_included_all_employees' ||
                                                                key === 'verification_checked'
                                                            ) {
                                                                dataValue = obj[key] === true ? 'True' : 'False';
                                                            }
                                                            const textColumnKeys = [
                                                                'datarestriction',
                                                                'georestriction',
                                                                'population',
                                                                'subpopulation_name',
                                                                'expertname',
                                                                'coach_name',
                                                                'samplevalue',
                                                                'orgsciallowed',
                                                                'org_science_other_text',
                                                            ];
                                                            if (textColumnKeys.includes(key)) {
                                                                const raw = getCellValue(obj, key);
                                                                dataValue =
                                                                    raw != null && raw !== '' ? String(raw) : '';
                                                            }
                                                            const styles =
                                                                key === 'approve_status'
                                                                    ? getStatusStyles(approve_status)
                                                                    : {};
                                                            return (
                                                                <td
                                                                    className="userTableContent ellipsisPro"
                                                                    key={key}
                                                                    // onClick={
                                                                    //     key === 'action'
                                                                    //         ? () => handleCellClick(id, action)
                                                                    //         : null
                                                                    // }
                                                                    onClick={
                                                                        key === 'action'
                                                                            ? () =>
                                                                                  handleCellClick(
                                                                                      id,
                                                                                      approve_status,
                                                                                      uniquesurveyreferencecode,
                                                                                      research_status,
                                                                                      benchmark_status
                                                                                  )
                                                                            : null
                                                                    }
                                                                    style={{
                                                                        width: widthTd,
                                                                        textAlign: align,
                                                                        cursor,
                                                                    }}
                                                                >
                                                                    <Tooltip
                                                                        title={dataValue}
                                                                        arrow
                                                                        classes={{ popper: 'cbmTooltip' }}
                                                                    >
                                                                        <span style={styles}>{dataValue}</span>
                                                                    </Tooltip>
                                                                </td>
                                                            );
                                                        }
                                                    )}
                                                </tr>
                                            </>
                                        );
                                    })}

                                {!filteredData.length ? (
                                    <div className="emptyList">
                                        <div>
                                            <h3>No survey list available</h3>
                                            <img src={CloudImage} alt="" />
                                        </div>
                                    </div>
                                ) : null}
                                {/* {surveyListLoading ? <LoaderToast /> : null}  */}
                            </tbody>
                        </table>
                    </AccordionDetails>
                </Accordion>
                {!!filteredData.length && filteredData.length > entryCount ? (
                    <div className="pagination">
                        <span onClick={handleFirstPageSlice} className={c({ inActive: page === 1 }, 'arrowBtn')}>
                            <img src={PaginationItems} alt="First Page" />
                        </span>
                        <span onClick={handlePrevPage} className={c({ inActive: page === 1 }, 'arrowBtn')}>
                            <img src={SmallLeft} alt="Previous Page" />
                        </span>

                        {Array(lastPage)
                            .fill(1)
                            .map((_, i) => i + 1)
                            .slice(min, max)
                            .map(index => (
                                <span
                                    key={index}
                                    className={c({ activePage: page === index }, 'paginationButton')}
                                    onClick={() => setPage(index)}
                                >
                                    {index}
                                </span>
                            ))}

                        <span onClick={handleNextPage} className={c({ inActive: page === lastPage }, 'arrowBtn')}>
                            <img src={ArrowForward} alt="Next Page" />
                        </span>
                        <span onClick={handleLastPageSlice} className={c({ inActive: page === lastPage }, 'arrowBtn')}>
                            <img src={ArrowDoubleForward} alt="Last Page" />
                        </span>

                        <div className="resultsPerPage">
                            <div className="resultHeading">Results Per Page</div>
                            <Select
                                IconComponent={KeyboardArrowDownSharp}
                                value={entryCount}
                                onChange={handleResultsPerPageChange}
                                MenuProps={{
                                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                                }}
                            >
                                {[10, 20, 30, 40, 50].map(pageItem => (
                                    <MenuItem key={pageItem} value={pageItem}>
                                        {pageItem}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                ) : null}

                {popupContent && (
                    <div className="popup">
                        <div className="popupContent">
                            <div className="realtimeCloseIcon">
                                <img src={CloseIcon} alt="" className="closeIcon" onClick={closePopup} />
                            </div>

                            <div>
                                <p className="approveOrRejectText"> Approve or reject the survey.</p>
                                <p className="surveyId">
                                    {' '}
                                    <span className="surveyIdText"> Survey ID: </span>{' '}
                                    {uniqueSurveyReferencecodeValue || ''}{' '}
                                </p>
                                <p>
                                    When you reject a survey, it is excluded from the Work-in-progress benchmark. You
                                    may approve it later, if required.
                                </p>
                                <p className="approveTheSurvey">Approve the survey</p>
                                <p className="approveTheSurveyText">
                                    You can select any one or both of the options given below{' '}
                                </p>

                                <div className="approvalOptions">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color="primary"
                                                name="approveAsWorkInProgress"
                                                checked={approveBMX}
                                                onChange={e => {
                                                    setApproveBMX(e.target.checked);
                                                    if (e.target.checked) {
                                                        setRejectionReason('');
                                                    }
                                                }}
                                            />
                                        }
                                        label={
                                            <span className="labelText">
                                                Benchmark Explorer (BMX)
                                                <Tooltip
                                                    title="Surveys that can be used for benchmarking (for GSDB update)"
                                                    arrow
                                                >
                                                    <span className="infoIcon">
                                                        <img src={InfoIcon} alt="" />
                                                    </span>
                                                </Tooltip>
                                            </span>
                                        }
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color="primary"
                                                name="approveForGlobal"
                                                checked={approveResearch}
                                                onChange={e => {
                                                    setApproveResearch(e.target.checked);
                                                    if (e.target.checked) {
                                                        setRejectionReason('');
                                                    }
                                                }}
                                            />
                                        }
                                        label={
                                            <span className="labelText">
                                                Research
                                                <Tooltip
                                                    title="Non-standard deployments or Pulses, that can be used for research. The data will be available for export only."
                                                    arrow
                                                >
                                                    <span className="infoIcon">
                                                        <img src={InfoIcon} alt="" />
                                                    </span>
                                                </Tooltip>
                                            </span>
                                        }
                                    />
                                </div>

                                <p className="rejectTheSurvey">Reject the survey</p>
                                <p className="rejectTheSurveyText">Select the reason for rejecting the survey</p>

                                <FormControl component="fieldset" className="rejectionReasons">
                                    <RadioGroup
                                        name="rejectionReason"
                                        value={rejectionReason}
                                        onChange={e => {
                                            setRejectionReason(e.target.value);
                                            if (e.target.value) {
                                                setApproveBMX(false);
                                                setApproveResearch(false);
                                            }
                                        }}
                                    >
                                        <FormControlLabel
                                            value="reject_and_track"
                                            control={<Radio color="primary" />}
                                            label={
                                                <span className="labelText">
                                                    Reject and Track
                                                    <Tooltip title="Lorem ipsum dolor sit amet con" arrow>
                                                        <span className="infoIcon">
                                                            <img src={InfoIcon} alt="" />
                                                        </span>
                                                    </Tooltip>
                                                </span>
                                            }
                                        />
                                    </RadioGroup>
                                </FormControl>

                                <div className="realtimePopupButton">
                                    <button type="button" onClick={closePopup} className="rejectBtn">
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setPopupContent(false);
                                            setPopupConfirmationContent(true);
                                        }}
                                        className="approveBtn"
                                        disabled={!approveBMX && !approveResearch && !rejectionReason}
                                    >
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {popupConfirmationContent && (
                    <div className="popup">
                        <div className="popupContent" style={{ width: '40%' }}>
                            <div className="realtimeCloseIcon">
                                <img src={CloseIcon} alt="" className="closeIcon" onClick={closePopup} />
                            </div>

                            <div>
                                {(approveBMX || approveResearch) && !rejectionReason && (
                                    <>
                                        <p className="approveOrRejectText">Sure you want to approve this survey?</p>
                                        <p className="surveyId">
                                            <span className="surveyIdText">Survey ID: </span>
                                            {uniqueSurveyReferencecodeValue || ''}
                                        </p>
                                        <p>
                                            Are you sure you want to approve the selected survey? This will make it
                                            available in the selected benchmarks.
                                        </p>

                                        <div className="realtimePopupButton">
                                            <button
                                                type="button"
                                                className="rejectBtn"
                                                onClick={() => {
                                                    setPopupConfirmationContent(false);
                                                    setPopupContent(true);
                                                }}
                                            >
                                                Back
                                            </button>
                                            <button type="button" className="approveBtn" onClick={handleApprove}>
                                                Approve
                                            </button>
                                        </div>
                                    </>
                                )}

                                {rejectionReason && !approveBMX && !approveResearch && (
                                    <>
                                        <p className="approveOrRejectText">Sure you want to reject this survey?</p>
                                        <p className="surveyId">
                                            <span className="surveyIdText">Survey ID: </span>
                                            {uniqueSurveyReferencecodeValue || ''}
                                        </p>
                                        <p>
                                            Are you sure you want to reject and track the selected survey? You may
                                            approve it later, if required.
                                        </p>

                                        <div className="realtimePopupButton">
                                            <button
                                                type="button"
                                                className="rejectBtn"
                                                onClick={() => {
                                                    setPopupConfirmationContent(false);
                                                    setPopupContent(true);
                                                }}
                                            >
                                                Back
                                            </button>
                                            <button type="button" className="approveBtn" onClick={handleReject}>
                                                Reject & Track
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {exportModalVisible && (
                    <div className="popup">
                        <div className="popupContent" style={{ width: '35%', padding: '30px' }}>
                            <div className="realtimeCloseIcon">
                                <img src={CloseIcon} alt="" className="closeIcon" onClick={handleExportModalClose} />
                            </div>

                            <h2 style={{ marginBottom: '16px' }}>Export results</h2>
                            <p style={{ marginBottom: '24px', color: '#666' }}>
                                Select the columns you want to export in an Excel format.
                            </p>

                            <div style={{ marginBottom: '24px' }}>
                                <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        id="metadata"
                                        checked={exportOptions.metadata}
                                        onChange={() => handleExportOptionChange('metadata')}
                                        color="primary"
                                        disableRipple
                                        style={{ padding: '4px' }}
                                    />
                                    <label
                                        htmlFor="metadata"
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        Metadata and survey demographics
                                    </label>
                                </div>

                                <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        id="scoreOHI"
                                        checked={exportOptions.scoreOHI}
                                        onChange={() => handleExportOptionChange('scoreOHI')}
                                        color="primary"
                                        disableRipple
                                        style={{ padding: '4px' }}
                                    />
                                    <label
                                        htmlFor="scoreOHI"
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        OHI scores
                                    </label>
                                </div>

                                <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        id="exScore"
                                        checked={exportOptions.exScore}
                                        onChange={() => handleExportOptionChange('exScore')}
                                        color="primary"
                                        disableRipple
                                        style={{ padding: '4px' }}
                                    />
                                    <label
                                        htmlFor="exScore"
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        Employee Experience scores
                                    </label>
                                </div>
                                <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        id="questionLevelScore"
                                        checked={exportOptions.questionLevelScore}
                                        onChange={() => handleExportOptionChange('questionLevelScore')}
                                        color="primary"
                                        disableRipple
                                        style={{ padding: '4px' }}
                                    />
                                    <label
                                        htmlFor="questionLevelScore"
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        Question-level scores
                                    </label>
                                </div>
                            </div>

                            <div className="realtimePopupButton">
                                <button type="button" onClick={handleExportModalClose} className="rejectBtn">
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={handleExport}
                                    className="approveBtn"
                                    disabled={
                                        !exportOptions.metadata &&
                                        !exportOptions.scoreOHI &&
                                        !exportOptions.exScore &&
                                        !exportOptions.questionLevelScore
                                    }
                                >
                                    Export
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showRefreshModal && (
                    <ConfirmModal handleAcceptAction={handleRefreshAction} closeAction={handleClose} message={msg} />
                )}
                {showRefreshModalMsg && refreshData.length && (
                    <ConfirmModal
                        handleAcceptAction={() => setRefreshModalMsg(false)}
                        closeAction={() => setRefreshModalMsg(false)}
                        message={detail}
                        success={success.length}
                        failed={failed.length}
                    />
                )}
            </div>
        </div>
    );
};

RealtimeDatabase.propTypes = {
    defaultRealTimeYear: PropTypes.number.isRequired,
    realtimeTotalData: PropTypes.object,
    realtimeSurveyList: PropTypes.array,
    getRealtimeApproval: PropTypes.func.isRequired,
    getRealtimeReject: PropTypes.func.isRequired,
    // hideSecondPopup: PropTypes.func.isRequired,
    secondPopupVisible: PropTypes.bool.isRequired,
    getRealtimeAnalytics: PropTypes.func.isRequired,
    getRealtimeSurveyList: PropTypes.func.isRequired,
    realtimeToggleFilterView: PropTypes.func.isRequired,
    renderRealtimeFilterApplied: PropTypes.object.isRequired,
    realtimeFilterString: PropTypes.string.isRequired,
    refreshMetaRequest: PropTypes.func.isRequired,
    refreshMetaData: PropTypes.func.isRequired,
    // renderFilterApplied: PropTypes.string.isRequired,
    realtimeFiltersApplied: PropTypes.bool,
};

RealtimeDatabase.defaultProps = {
    realtimeTotalData: {},
    realtimeSurveyList: [],
    realtimeFiltersApplied: false,
};

export default RealtimeDatabase;
